/**
 * Chair Dinkum - Capisco Add-ons Dropdown
 * Adds gas lift, footring, and step up as optional extras on product pages.
 * Products are added to cart separately alongside the main product.
 */
(function() {
  'use strict';

  // Add-on product configuration
  var ADDONS = {
    gaslift: {
      title: 'Gas Lift',
      thumbnail: 'https://cdn.shopify.com/s/files/1/1023/3973/files/hag-capisco-gas-lift-black.png?v=1780925690',
      handle: 'hag-capisco-gas-lift',
      url: '/products/hag-capisco-gas-lift',
      productId: 7465304326199,
      defaultLabel: '200mm (included)',
      options: [
        { label: '150mm (+$150.00)', height: '150mm', price: 150 },
        { label: '265mm (+$150.00)', height: '265mm', price: 150 }
      ]
    },
    footring: {
      title: 'Footring',
      subtitle: 'Recommended for use with the high gas lift',
      thumbnail: 'https://cdn.shopify.com/s/files/1/1023/3973/files/footring_black.jpg?v=1780926393',
      handle: 'hag-capisco-footring',
      url: '/products/hag-capisco-footring',
      productId: 7465304260663,
      defaultLabel: 'None',
      options: [
        { label: 'Add Footring - matches base colour (+$220.00)', matchBase: true, price: 220 }
      ]
    },
    stepup: {
      title: 'StepUp',
      thumbnail: 'https://cdn.shopify.com/s/files/1/1023/3973/files/hag-step-up-black.jpg?v=1780927147',
      handle: 'hag-step-up',
      url: '/products/hag-step-up',
      productId: 7465304490039,
      defaultLabel: 'None',
      options: [
        { label: 'Add HÅG StepUp (+$363.00)', price: 363 }
      ]
    }
  };

  // Variant data will be fetched from Shopify JSON
  var variantCache = {};

  function fetchProductVariants(handle, callback) {
    if (variantCache[handle]) {
      callback(variantCache[handle]);
      return;
    }
    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/products/' + handle + '.json', true);
    xhr.onload = function() {
      if (xhr.status === 200) {
        var data = JSON.parse(xhr.responseText);
        variantCache[handle] = data.product.variants;
        callback(data.product.variants);
      }
    };
    xhr.send();
  }

  function findVariantId(variants, options) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      if (options.height) {
        // Gas lift: option1 = height, option2 = colour
        if (v.option1 !== options.height) match = false;
        if (options.colour && v.option2 !== options.colour) match = false;
      } else if (options.colour) {
        // Footring: option1 = colour (no height dimension)
        if (v.option1 !== options.colour) match = false;
      }
      if (match) return v.id;
    }
    return variants[0].id;
  }

  function getSelectedBaseColour() {
    // Read from the hidden variant select - option text format:
    // "Gabriel Select SC60999 / Black Base - $1,858.00 AUD"
    // "Light Grey/SC60131 / Black Base - $1,108.80 AUD" (8010 has slash in colour name)
    var variantSelect = document.querySelector('select[name="id"]');
    if (variantSelect) {
      var selectedOption = variantSelect.options[variantSelect.selectedIndex];
      if (selectedOption) {
        var text = selectedOption.textContent;
        // Find " - $" first (the price separator), then find the LAST slash before it
        var priceIdx = text.indexOf(' - $');
        if (priceIdx === -1) priceIdx = text.indexOf(' -');
        var lastSlash = text.lastIndexOf('/', priceIdx);
        if (lastSlash > -1 && priceIdx > -1) {
          var baseText = text.substring(lastSlash + 2, priceIdx).trim();
          // baseText is like "Black Base" - extract colour
          return baseText.replace(' Base', '');
        }
      }
    }
    // Fallback: try Impulse native variant inputs
    var materialFieldset = document.querySelector('fieldset[data-option-index="1"]');
    if (materialFieldset) {
      var selected = materialFieldset.querySelector('input:checked');
      if (selected) {
        return selected.value.replace(' Base', '');
      }
    }
    return 'Black';
  }

  function buildAddonSection() {
    // Find the product form
    var productForm = document.querySelector('form[action="/cart/add"]');
    if (!productForm) return;

    // Check if addon section already exists
    if (document.getElementById('cd-addons-section')) return;

    // Create the addon container
    var container = document.createElement('div');
    container.id = 'cd-addons-section';
    container.style.cssText = 'margin-top:4px;margin-bottom:12px;padding:12px 0 0;border-top:1px solid #e8e8e8;'; // PDP2: compact

    var heading = document.createElement('p');
    heading.style.cssText = 'font-size:0.65rem;letter-spacing:0.12em;text-transform:uppercase;color:#888;margin-bottom:8px;font-weight:500;';
    heading.textContent = 'OPTIONAL EXTRAS';
    container.appendChild(heading);

    // Build each dropdown
    var addonKeys = ['gaslift', 'footring', 'stepup'];
    for (var k = 0; k < addonKeys.length; k++) {
      var key = addonKeys[k];
      var addon = ADDONS[key];

      var row = document.createElement('div');
      row.style.cssText = 'margin-bottom:8px;display:flex;align-items:center;gap:10px;';
      var thumb = document.createElement('img');
      thumb.src = addon.thumbnail;
      thumb.alt = addon.title;
      thumb.style.cssText = 'width:36px;height:36px;object-fit:contain;border-radius:4px;border:1px solid #eee;background:#fff;flex-shrink:0;';
      var label = document.createElement('label');
      label.style.cssText = 'font-size:0.8125rem;font-weight:500;flex:0 0 96px;min-width:0;line-height:1.3;text-transform:none;letter-spacing:normal;text-align:left;margin:0;';
      if (addon.url) {
        label.innerHTML = '<a href="' + addon.url + '" style="color:inherit;text-decoration:none;border-bottom:1px solid #ccc;">' + addon.title + '</a>';
      } else {
        label.textContent = addon.title;
      }
      label.setAttribute('for', 'cd-addon-' + key);

      var select = document.createElement('select');
      select.id = 'cd-addon-' + key;
      select.setAttribute('data-addon-key', key);
      select.style.cssText = 'font-size:0.8125rem;padding:8px 12px;border:1px solid #ddd;border-radius:4px;background:#fff;flex:1 1 auto;min-width:0;width:100%;max-width:280px;cursor:pointer;';

      // Default "none" option
      var defaultOpt = document.createElement('option');
      defaultOpt.value = '';
      defaultOpt.textContent = addon.defaultLabel;
      select.appendChild(defaultOpt);
      // Add description if present
      if (addon.description) {
        var desc = document.createElement('p');
        desc.style.cssText = 'font-size:0.75rem;color:#888;margin:4px 0 0 0;';
        desc.textContent = addon.description;
      }

      // Add-on options
      for (var i = 0; i < addon.options.length; i++) {
        var opt = document.createElement('option');
        opt.value = JSON.stringify(addon.options[i]);
        opt.textContent = addon.options[i].label;
        select.appendChild(opt);
      }

      row.appendChild(thumb);
      row.appendChild(label);
      row.appendChild(select);
      if (addon.subtitle) {
        // PDP2: subtitle sits under the label instead of a separate right-hand column (stops a wide row on mobile)
        var subtitleDiv = document.createElement('span');
        subtitleDiv.textContent = 'Recommended with the high gas lift';
        subtitleDiv.style.cssText = 'display:block;font-size:0.6875rem;color:#666;font-weight:400;line-height:1.3;margin-top:2px;text-transform:none;letter-spacing:normal;';
        label.appendChild(subtitleDiv);
      }
      container.appendChild(row);
    }

    // Add a subtle info line
    var info = document.createElement('p');
    info.style.cssText = 'font-size:0.75rem;color:#888;margin-top:4px;margin-bottom:0;';
    info.textContent = 'Selected extras will be added to your cart alongside the chair.';
    container.appendChild(info);

    // Insert before the form (between stock indicator and Add to Cart button)
    // PDP2: extras sit with the configuration (before the reassurance rows) when the shared component is present;
    // otherwise unchanged (before the form)
    var cdSlot = document.getElementById('cd-addons-slot');
    var cdAnchor = document.querySelector('[data-cd-reassurance]');
    if (cdSlot) {
      cdSlot.appendChild(container);
    } else if (cdAnchor && cdAnchor.parentNode) {
      cdAnchor.parentNode.insertBefore(container, cdAnchor);
    } else {
      productForm.parentNode.insertBefore(container, productForm);
    }

    // Intercept the Add to Cart form submission
    interceptAddToCart(productForm);
  }

  function interceptAddToCart(form) {
    form.addEventListener('submit', function(e) {
      var addons = getSelectedAddons();
      if (addons.length === 0) return; // No addons, let normal submission proceed

      e.preventDefault();
      e.stopPropagation();

      // Get the main product variant ID from the form
      var mainVariantInput = form.querySelector('select[name="id"], input[name="id"]');
      var mainVariantId = mainVariantInput ? mainVariantInput.value : null;

      if (!mainVariantId) return;

      // Build cart items array
      var items = [{ id: parseInt(mainVariantId), quantity: 1 }];

      // Resolve addon variant IDs and add to cart
      var pending = addons.length;
      var addonItems = [];

      for (var i = 0; i < addons.length; i++) {
        (function(addon) {
          fetchProductVariants(addon.handle, function(variants) {
            var variantId;
            if (addon.key === 'gaslift') {
              // Match height + current base colour
              var baseColour = getSelectedBaseColour();
              variantId = findVariantId(variants, { height: addon.data.height, colour: baseColour });
            } else if (addon.key === 'footring') {
              // Auto-match footring colour to selected base colour
              var baseColour = getSelectedBaseColour();
              variantId = findVariantId(variants, { colour: baseColour });
            } else {
              // Step up, unblocking tool - single variant products
              variantId = addon.variantId || variants[0].id;
            }
            addonItems.push({ id: variantId, quantity: 1 });
            pending--;
            if (pending === 0) {
              // All resolved, submit to cart
              submitToCart(items.concat(addonItems));
            }
          });
        })(addons[i]);
      }
    });
  }

  function getSelectedAddons() {
    var addons = [];
    var selects = document.querySelectorAll('#cd-addons-section select');
    for (var i = 0; i < selects.length; i++) {
      var sel = selects[i];
      if (sel.value) {
        var data = JSON.parse(sel.value);
        var key = sel.getAttribute('data-addon-key');
        addons.push({
          key: key,
          handle: ADDONS[key].handle,
          data: data
        });
      }
    }
    return addons;
  }

  function submitToCart(items) {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onload = function() {
      if (xhr.status === 200) {
        // Redirect to cart or show success
        window.location.href = '/cart';
      } else {
        // Fallback: try adding items one by one
        alert('Some items could not be added. Please try again.');
      }
    };
    xhr.send(JSON.stringify({ items: items }));
  }

  // Initialize - uses polling to handle AJAX page transitions
  function init() {
    var url = window.location.pathname;
    var validSlugs = [
      '/products/hag-capisco',
      '/products/capisco-saddle-chair-hag-capisco-puls-8010-chair-dinkum',
      '/products/hag-capisco-saddle-chair-8020'
    ];
    var isCapiscoPage = false;
    for (var i = 0; i < validSlugs.length; i++) {
      if (url.indexOf(validSlugs[i]) !== -1) {
        isCapiscoPage = true;
        break;
      }
    }
    if (!isCapiscoPage || url.indexOf('footring') !== -1 || url.indexOf('gas-lift') !== -1 || url.indexOf('step-up') !== -1 || url.indexOf('castors') !== -1 || url.indexOf('quickstep') !== -1 || url.indexOf('glides') !== -1) {
      // Not a Capisco page - remove addon section if it exists from a previous page
      var existing = document.getElementById('cd-addons-section');
      if (existing) existing.remove();
      return;
    }

    // Wait for product form to be available
    var form = document.querySelector('form[action="/cart/add"]');
    if (form && !document.getElementById('cd-addons-section')) {
      buildAddonSection();
    }
  }

  // Poll every 500ms to catch AJAX navigations
  setInterval(init, 500);

  // Also run immediately
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
